export const CANCELLED = 'CANCELLED';
export const CANCELLATION_PENDING = 'CANCELLATION_PENDING';
export const ACTIVE = 'ACTIVE';
export const ACTIVE_SINGLE_ANNUAL = 'ACTIVE_SINGLE_ANNUAL';
export const ACTIVE_MONTHLY_CONTINUOUS_NON_LTP = 'ACTIVE_MONTHLY_CONTINUOUS_NON_LTP';
export const LAPSED = 'LAPSED';
export const CONFIRMED = 'CONFIRMED';
export const EXPIRED = 'EXPIRED';
